import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal } from "react-icons/tb";
import { ValutField, ValutInput } from "../../../Components/Atoms/ValutInput";
import { ModernFilterBar } from "../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersDateSection,
} from "../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_RECEIPTS_FILTERS,
  buildReceiptsFilterTags,
  exportReceiptsCsv,
  hasActiveReceiptsFilters,
  isReceiptsChipFilterActive,
  removeReceiptsFilterTag,
} from "./receiptsFilters";

const ReceiptsMoreFiltersForm = ({ draft, onChange }) => (
  <div className="extract-more-filters-form">
    <MoreFiltersDateSection draft={draft} onChange={onChange} />
    <MoreFiltersAmountSection draft={draft} onChange={onChange} idPrefix="receipts-more" />
    <section className="extract-more-filters-form__section">
      <ValutField label={intl.get("receipts.filterTraceId")} htmlFor="receipts-more-trace-id">
        <ValutInput
          id="receipts-more-trace-id"
          value={draft.traceId}
          onChange={(event) => onChange({ ...draft, traceId: event.target.value })}
        />
      </ValutField>
    </section>
    <section className="extract-more-filters-form__section">
      <ValutField label={intl.get("receipts.filterExternalId")} htmlFor="receipts-more-external-id">
        <ValutInput
          id="receipts-more-external-id"
          value={draft.externalId}
          onChange={(event) => onChange({ ...draft, externalId: event.target.value })}
        />
      </ValutField>
    </section>
  </div>
);

export const ReceiptsFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
}) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isReceiptsChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isReceiptsChipFilterActive(filters, "amount"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="receipts-filter" />;
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_RECEIPTS_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isReceiptsChipFilterActive(filters, "more")}
      buildFilterTags={buildReceiptsFilterTags}
      hasActiveFilters={hasActiveReceiptsFilters}
      removeFilterTag={removeReceiptsFilterTag}
      onExport={exportReceiptsCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <ReceiptsMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
      }}
    />
  );
};
